export default __webpack_public_path__ + "static/media/property_1_14.44d2c6ac.webp";